// Shared category-name → slug mapping.
// Lookup order: explicit metadata slug → `algolia.categories` map → slugified name.

import { decode } from "html-entities";

export const normalizeCategoryName = (name) =>
  decode(String(name || "").trim());

export const normalizeCategoryLookupKey = (name) =>
  normalizeCategoryName(name).toLowerCase();

export const slugifyCategory = (name) =>
  normalizeCategoryName(name)
    .replace(/&amp;|&#038;|&/gi, " ")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .toLowerCase();

export const getCategorySlug = (name, metadata = {}, categoryMap) => {
  if (metadata.slug) {
    return metadata.slug;
  }

  const normalized = normalizeCategoryName(name);
  const categories =
    categoryMap ||
    (typeof algolia !== "undefined" ? algolia?.categories : undefined);

  if (categories) {
    if (categories[normalized]) {
      return categories[normalized];
    }

    if (name && categories[name]) {
      return categories[name];
    }
  }

  return slugifyCategory(normalized);
};
